import { reactive, ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import * as CommonInquiry from '@/logic/common/CommonInquiry'
import * as CommonEstimate from '@/logic/common/CommonEstimate'
import * as apiInquiry from '@/api/inquiry'
import * as common from '@/util/common'

// お見積り（ログイン前）（入力）画面
export const getGroupIndex = (props, context) => {

  const group1 = reactive({

    device: computed(() => {
      return store.state.common.device 
    }),

    // フォーム入力値
    name: '',
    kana: computed(CommonInquiry.computedH2Z('kana')),
    charge_name: '',
    department: '',
    postnumber: computed(CommonInquiry.computedZ2H('postnumber')),
    address: computed(CommonInquiry.computedH2Z('address')),
    address2: computed(CommonInquiry.computedH2Z('address2')),
    address3: computed(CommonInquiry.computedH2Z('address3')),
    address4: computed(CommonInquiry.computedH2Z('address4')),
    email: computed(CommonInquiry.computedZ2H('email')),
    email_check: computed(CommonInquiry.computedZ2H('email_check')),

    occupation_classification: '', // 職業区分コード(文字列)
    occupation: '', // 業種・職業コード(文字列)

    // 職業選択肢(プルダウン)生成用リスト
    occupationClassificationList: [],

    // 選択された職業区分
    selectedOccupationClassificationName: computed(() => {
      return CommonInquiry.getSelectedOccupationClassificationName(group1, '業種を選んでください')
    }),

    // 業種・職業名の選択肢(プルダウン)用リスト
    occupationList: computed(() => {
      return CommonInquiry.getOccupationList(group1)
    }),

    // 選択された業種・職業名
    selectedOccupationName: computed(() => {
      return CommonInquiry.getSelectedOccupationName(group1, '職業を選んでください')
    }),

    tel: computed(CommonInquiry.computedZ2H('tel')),
    tel2: computed(CommonInquiry.computedZ2H('tel2')),
    extension: computed(CommonInquiry.computedZ2H('extension')),
    fax: computed(CommonInquiry.computedZ2H('fax')),
    introducer: '',
    note: '',
    productsLicenses: [], // 選択した商品＆ライセンス数のリスト

    packagesAndProducts: [], // パッケージ＆商品一覧データ

    // 入力エラーフラグ
    isError: false,

    // フォーム入力エラーメッセージ
    error_name: '',
    error_kana: '',
    error_charge_name: '',
    error_department: '',
    error_postnumber: '',
    error_address: '',
    error_address2: '',
    error_address3: '',
    error_address4: '',
    error_email: '',
    error_email_check: '',
    error_occupation_classification: '',
    error_occupation: '',
    error_tel: '',
    error_tel2: '',
    error_extension: '',
    error_fax: '',
    error_introducer: '',
    error_note: '',
    error_productsLicenses: '',

    // 住所エリア表示状態
    visibleAddress: computed(() => {
      return store.state.inquiry.isAddressAreaVisible
    }),

    // 住所選択ダイアログ表示フラグ
    visiblePostnumberDuplicated: false,

    // 重複した住所のリスト
    duplicatedAddressList: [],

    // 職業（区分）プルダウンの表示フラグ
    displayOccupationClassificationSelect: false,
    //　職業（業種・職業）プルダウンの表示フラグ
    displayOccupationSelect: false,

    // 送信中フラグ（二重送信防止用）
    isProcessing: false,

    // パッケージ・商品一覧ロード完了フラグ
    isPackageAndLicensesLoaded: false,

    /**
     * 初期表示
     */
    init: () => {

      // 確認画面から戻ってきた場合、ストアからデータをロード
      group1.name = store.state.inquiry.name ?? ''
      group1.kana = store.state.inquiry.kana ?? ''
      group1.charge_name = store.state.inquiry.charge_name ?? ''
      group1.department = store.state.inquiry.department ?? ''
      group1.postnumber = store.state.inquiry.postnumber ?? ''
      group1.address = store.state.inquiry.address ?? ''
      group1.address2 = store.state.inquiry.address2 ?? ''
      group1.address3 = store.state.inquiry.address3 ?? ''
      group1.address4 = store.state.inquiry.address4 ?? ''
      group1.email = store.state.inquiry.email ?? ''
      group1.email_check = store.state.inquiry.email_check ?? ''
      group1.occupation_classification = store.state.inquiry.occupation_classification ?? ''
      group1.occupation = store.state.inquiry.occupation ?? ''
      group1.tel = store.state.inquiry.tel ?? ''
      group1.tel2 = store.state.inquiry.tel2 ?? ''
      group1.extension = store.state.inquiry.extension ?? ''
      group1.fax = store.state.inquiry.fax ?? ''
      group1.introducer = store.state.inquiry.introducer ?? ''
      group1.note = store.state.inquiry.note ?? ''
      group1.productsLicenses = store.state.inquiry.productsLicenses ?? []
      group1.occupationClassificationList = store.state.inquiry.occupationClassificationList ?? [] // 職業選択肢(プルダウン)生成用リスト

      if (group1.occupationClassificationList.length === 0) {
        // 職業選択肢表示用のデータをロード
        CommonInquiry.loadJobs(group1)
      }

      // パッケージ・商品一覧APIをコール
      const isTrial = 0 // 0=通常
      const isOnlyContract = 0 // 0=契約商品以外も含む
      CommonEstimate.loadPackageAndLicenses(false, group1, isTrial, isOnlyContract)
    },

    /**
     * 職業のラジオボタンをプルダウン表示
     */
    onMouseEnterOccupationClassificationSelectItem: () => {
      if (group1.device === 'sp') {
        return 
      }
      group1.displayOccupationClassificationSelect = true
    },
    onMouseLeaveOccupationClassificationSelectItem: () => {
      if (group1.device === 'sp') {
        return 
      }
      group1.displayOccupationClassificationSelect = false
    },
    onClickOccupationClassificationSelectItem: () => {
      if (group1.device === 'pc') {
        return 
      }
      group1.displayOccupationClassificationSelect = true
      group1.displayOccupationSelect = false
    },
    onMouseEnterOccupationSelectItem: () => {
      if (group1.device === 'sp') {
        return 
      }
      group1.displayOccupationSelect = true
    },
    onMouseLeaveOccupationSelectItem: () => {
      if (group1.device === 'sp') {
        return 
      }
      group1.displayOccupationSelect = false
    },
    onClickOccupationSelectItem: () => {
      if (group1.device === 'pc') {
        return 
      }
      group1.displayOccupationSelect = true
      group1.displayOccupationClassificationSelect = false
    },

    /**
     * 購入ボタンをクリックした場合
     */
    onBuyButonClicked: ({item}) => {
      
      // エラーメッセージが表示されていればクリアする
      group1.error_productsLicenses = ''

      CommonEstimate.onBuyButonClicked(group1, {item})
    },

    /**
     * ライセンス数の選択肢をクリックした場合
     */
    onLicensesChoicesChanged: ({item, licenses}) => {
      CommonEstimate.onLicensesChoicesChanged(group1, {item, licenses})
    },

    /**
     * ライセンスのラジオボタンをプルダウン表示
     */
    onMouseEnterLicenseSelectItem: (item) => {
      if (group1.device === 'sp') {
        return 
      }
      item.display_licenses_select = true
    },
    onMouseLeaveLicenseSelectItem: (item) => {
      if (group1.device === 'sp') {
        return 
      }
      item.display_licenses_select = false
    },
    onClickLicenseSelectItem: (item) => {
      if (group1.device === 'pc') {
        return 
      }
      item.display_licenses_select = true
    },
    
    /**
     * リセットボタン（消しゴムボタン）をクリックした場合
     */
    onResetButtonClicked: ({item}) => {
      CommonEstimate.onResetButtonClicked(group1, {item})
    },

    /**
     * 住所取得
     * @param postnumber 郵便番号(半角数字7桁)
     * 
     */
    fetchAddresses: (postnumber) => {

      // 住所エリアを表示
      store.dispatch('inquiry/setAddressAreaVisible', true)

      // 住所データをロード
      CommonInquiry.loadAddresses(group1)
    },

    /**
     * 職業区分が選択された場合 → 職業区分に属する職業一覧を表示する
     */
    onOccupationClassificationListSelected: () => {
   
      // 表示していたプルダウンリストを非表示にする
      group1.displayOccupationClassificationSelect = false
    },

    /**
     * 職業が選択された場合
     */
    onOccupationListSelected: () => {
      
      // 表示していたプルダウンリストを非表示にする
      group1.displayOccupationSelect = false
    },

    /**
     * 住所選択ダイアログのサブミットボタンを押した場合
     */
    onEstimatePostnumberDuplicatedSubmitted: (eventMap) => {
      group1.address = eventMap.address ?? ''
      group1.address2 = eventMap.address2 ?? ''
      group1.visiblePostnumberDuplicated = false
    },

    /**
     * 同意した上で進むボタンを押下した時
     */
    onSubmitButtonClicked: () => {

      if (group1.postnumber !== '') {
        // 郵便番号を入力したが、住所検索ボタンを押さず、住所エリアを表示しなかった場合に、
        // 住所エリアを表示させるための設定
        store.dispatch('inquiry/setAddressAreaVisible', true)
      }

      // 見積もりを希望するパッケージのデータを「商品IDと購入ライセンス数のリスト」に整形
      const productsLicensesWork = []
      for (let i = 0; i < group1.packagesAndProducts.length; i++) {
        if (group1.packagesAndProducts[i].is_bought && group1.packagesAndProducts[i].licenses > 0) {
          const map = {
            id: group1.packagesAndProducts[i].product_id,
            licenses: group1.packagesAndProducts[i].licenses
          }
          productsLicensesWork.push(map)
        }
      }
      group1.productsLicenses = productsLicensesWork

      // 入力チェック
      const actionAfterCompletion = (group1, isError) => {

        // 選択した商品
        if (group1.productsLicenses.length === 0) {
          group1.error_productsLicenses = '見積もりを希望する「パッケージ/商品」の見積もりボタンが押下されていません。'
          isError = true
        }

        group1.isError = isError

        if (group1.isError) {
          // 入力エラーが存在した場合

          // 画面の最上部にスクロールする
          common.scrollAreaTop('html')

          return false
        }

        // 入力値
        const inputParams = {
          name: group1.name, 
          kana: group1.kana,
          charge_name: group1.charge_name,
          department: group1.department,
          postnumber: group1.postnumber,
          address: group1.address,
          address2: group1.address2,
          address3: group1.address3,
          address4: group1.address4,
          email: group1.email,
          email_check: group1.email_check,
          occupation_classification: group1.occupation_classification,
          occupation: group1.occupation,
          tel: group1.tel,
          tel2: group1.tel2,
          extension: group1.extension,
          fax: group1.fax,
          introducer: group1.introducer,
          note: group1.note,
          productsLicenses: group1.productsLicenses,
          occupationClassificationList: group1.occupationClassificationList // 職業の選択肢(プルダウン)生成用リスト
        }
    
        // ストアに入力値を保持
        store.dispatch('inquiry/setFormInputValues', inputParams)

        router.push({ path: '/public/estimate/confirm' })
      }
      CommonInquiry.checkInput(group1, actionAfterCompletion)
    }
  })

  return group1
}

// お見積り（ログイン前）（確認）画面
export const getGroupConfirm = () => {

  const group1 = reactive({

    // 表示項目
    name: '',
    kana: '',
    charge_name: '',
    department: '',
    postnumber: '',
    address: '',
    address2: '',
    address3: '',
    address4: '',
    email: '',

    occupation_classification: '', // 職業区分コード(文字列)
    occupation: '', // 業種・職業コード(文字列)

    // 職業選択肢(プルダウン)生成用リスト
    occupationClassificationList: [],

    // 選択された職業区分
    selectedOccupationClassificationName: computed(() => {
      return CommonInquiry.getSelectedOccupationClassificationName(group1, '')
    }),

    // 選択された業種・職業名
    selectedOccupationName: computed(() => {
      return CommonInquiry.getSelectedOccupationName(group1, '')
    }),

    tel: '',
    tel2: '',
    extension: '',
    fax: '',
    introducer: '',
    note: '',
    noteDisp: computed(() => {
      let value = group1.note
      value = common.escapeHTML(value)
      return value.replace(/\r?\n/g, '<br>')
    }),
    productsLicensesDisp: [], // 選択した商品情報のリスト（選択パッケージ＆ライセンス情報一覧APIの値を格納し表示する）

    // パッケージ・商品一覧ロード完了フラグ
    isPackageAndLicensesLoaded: false,

    /**
     * 初期表示
     */
    init: () => {

      // ストアからデータをロード
      group1.name = store.state.inquiry.name ?? ''
      group1.kana = store.state.inquiry.kana ?? ''
      group1.charge_name = store.state.inquiry.charge_name ?? ''
      group1.department = store.state.inquiry.department ?? ''
      group1.postnumber = store.state.inquiry.postnumber ?? ''
      group1.address = store.state.inquiry.address ?? ''
      group1.address2 = store.state.inquiry.address2 ?? ''
      group1.address3 = store.state.inquiry.address3 ?? ''
      group1.address4 = store.state.inquiry.address4 ?? ''
      group1.email = store.state.inquiry.email ?? ''
      group1.occupation_classification = store.state.inquiry.occupation_classification ?? ''
      group1.occupation = store.state.inquiry.occupation ?? ''
      group1.tel = store.state.inquiry.tel ?? ''
      group1.tel2 = store.state.inquiry.tel2 ?? ''
      group1.extension = store.state.inquiry.extension ?? ''
      group1.fax = store.state.inquiry.fax ?? ''
      group1.introducer = store.state.inquiry.introducer ?? ''
      group1.note = store.state.inquiry.note ?? ''
      group1.productsLicenses = store.state.inquiry.productsLicenses ?? []
      group1.occupationClassificationList = store.state.inquiry.occupationClassificationList ?? [] // 職業選択肢(プルダウン)生成用リスト

      // 選択パッケージ＆ライセンス情報一覧
      const type = 3 // 3(お見積り・確認)
      CommonEstimate.loadSelectedPackageAndLicenses(group1, type, store.state.inquiry.productsLicenses)
    },

    /**
     * 確定ボタンクリック時
     */
    onSubmitButtonClicked: () => {

      // 二重送信防止
      if (group1.isProcessing) {
        const payload = {
          title: '二重送信エラー',
          text: '短い時間に複数回送信ボタンが押されました。\n二重送信の可能性があるため、2度目以降の処理を中断します。'
        }
        store.dispatch('common/showNotice', payload)
        return
      }

      // 送信中フラグ（二重送信防止用）をtrueに設定
      group1.isProcessing = true

      // 画面リロードにより入力データが消えた場合に登録できないようにする。
      // 入力チェック
      const actionAfterCompletion = (group1, isError) => {

        // 選択した商品
        if (group1.productsLicenses.length === 0) {
          isError = true
        }
        if (isError) {
          // 入力エラーが存在した場合

          store.dispatch('common/showNotice', { title: 'エラー', text: '入力データが設定されていません。' })
          return false
        }

        // 無料トライアル・見積り＆お問い合わせ登録APIをコール

        const params = {
          type: 1, // 1=見積もり（ログイン前）
          name: group1.name,
          kana: group1.kana,
          charge_name: group1.charge_name,
          department: group1.department,
          postnumber: group1.postnumber,
          address: group1.address,
          address2: group1.address2,
          address3: group1.address3,
          address4: group1.address4,
          email: group1.email,
          occupation_classification: group1.occupation_classification,
          occupation: group1.occupation,
          tel: group1.tel,
          extension: group1.extension,
          tel2: group1.tel2,
          fax: group1.fax,
          introducer: group1.introducer,
          note: group1.note,
          products_licenses: group1.productsLicenses
        }

        store.dispatch('common/showLoading')
        apiInquiry.registerTrialEstimateInquiry(params)
          .then(response => {
            if (response) {
              const { data } = response

              if (data.status === 0) {
                // 成功の場合

                // 契約IDをストアに保存
                const agreementId = data.agreement_id
                store.dispatch('inquiry/setAgreementId', agreementId)

                // 完了画面に遷移
                router.push({ path: '/public/estimate/complete' })
              } else {
                // エラーの場合
                const errorMessageMap = data.validation_message ?? {}
                const keys = Object.keys(errorMessageMap)
                const errorMessages = []
                for (let i = 0; i < keys.length; i++) {
                  const value = errorMessageMap[keys[i]]
                  errorMessages.push(value)
                }
                const errorMessage = errorMessages.join('\n')
                store.dispatch('common/showNotice', { title: 'エラー', text: errorMessage })
              }

            }
          })
          .finally(() => {
            // 送信中フラグ（二重送信防止用）をfalseに設定
            group1.isProcessing = false

            store.dispatch('common/hideLoading')
          })        
      }
      CommonInquiry.checkInput(group1, actionAfterCompletion)
    }
  })

  return group1
}

// お見積り（ログイン前）（完了）画面
export const getGroupComplete = () => {

  const group1 = reactive({
    applicationNo: '', // 申込No
    created: '', // 申込日
    createdDisp: computed(() => {
      return common.formatDate(group1.created) 
    }),
    productsLicensesDisp: [], // 選択した商品情報のリスト（選択パッケージ＆ライセンス情報一覧APIの値を格納し表示する）

    // パッケージ・商品一覧ロード完了フラグ
    isPackageAndLicensesLoaded: false,

    /**
     * 初期表示
     */
    init: () => {
      // 選択パッケージ＆ライセンス情報一覧
      const type = 4 // 4(お見積り・完了)
      CommonEstimate.loadSelectedPackageAndLicenses(group1, type, store.state.inquiry.productsLicenses)

      // ストアに保持している値を全クリア
      store.dispatch('inquiry/clearAllStates')
    }
  })

  return group1
}
